import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Store from '../../stores/Store'
import { FormCheckbox } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class Checkbox extends Component {
  static propTypes = {
    ...FormCheckbox.propTypes,
    store: PropTypes.instanceOf(Store).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func // could be useful if you want to parse value to form value
  }

  static defaultProps = {
    errorPointing: 'above'
  }

    handleOnChangeInput = (e, data) => {
      const { store, name } = this.props
      store.set(name, data.checked)
      store.resetErrorMessageField(name)
    }

    render () {
      const {
        store,
        defaultValue,
        name,
        options,
        onChange,
        castValue,
        parseValue,
        errorPointing,
        error,
        ...props
      } = this.props
      const value = store.get(name, defaultValue || false)
      const valueError = store.getErrorMessageField(name)
      return (
        <FormCheckbox
          checked={parseValue ? parseValue(value) : value}
          name={name}
          error={valueError ? { content: valueError, pointing: errorPointing } : error}
          onChange={onChange || this.handleOnChangeInput}
          {...props}
        />
      )
    }
}
export default Checkbox
